import { apiClient } from './client';

export interface User {
    id: string;
    email: string;
    name: string;
    role: string;
    /**
     * Sólo en una sesión de persona (el login por mail): si es dueño de Accesos y qué es. `rol` y
     * `comercios` faltan en una sesión guardada antes de los roles (Activa usa el rol del canje).
     */
    acceso?: { esDueno: boolean; rol?: 'equipo' | 'comercio'; comercios?: string[] };
}

export interface AuthResponse {
    user: User;
    accessToken: string;
    expiresIn: number;
}

export const authApi = {
    requestOTP: async (email: string) => {
        const response = await apiClient.post<{ success: boolean; data: { message: string, expiresIn: number, otp?: string } }>('/auth/request-otp', { email });
        return response.data;
    },

    verifyOTP: async (email: string, code: string) => {
        const response = await apiClient.post<{ success: boolean; data: AuthResponse }>('/auth/verify-otp', { email, code });
        return response.data;
    },

    logout: async () => {
        const response = await apiClient.post<{ success: boolean }>('/auth/logout');
        return response.data;
    },

    // Optional: manually trigger refresh (usually handled by interceptor)
    // `user` puede faltar en un backend viejo: AuthContext lo trata como sesión no restaurada.
    refreshToken: async () => {
        const response = await apiClient.post<{ success: boolean; data: { accessToken: string; expiresIn: number; user?: User } }>('/auth/refresh');
        return response.data;
    }
};
